import { useMutation, useQueryClient } from 'react-query'
import { axios } from '../../../lib'

export const deleteNotification = (CD_ORCAMENTO: string): Promise<any> => {
  return axios.put(`/notifications/${CD_ORCAMENTO}`)
}

export function useDeleteNotification() {
  const queryClient = useQueryClient()

  return useMutation(deleteNotification, {
    onSuccess: () => {
      queryClient.invalidateQueries('notifications')
    },
    onError: (error: unknown) => {
      console.error(error)
    }
  })
}
